<template>
  <div class="v2-stores-list-container">
    <div class="v2-stores-list-tabs">
      <V2Button
        :variant="selectedStoreOption === STORE_OPTION.BY_STORE ? 'primary' : 'ghost'"
        block
        @click="selectedStoreOption = STORE_OPTION.BY_STORE"
      >
        {{ STORE_OPTION.BY_STORE }}
      </V2Button>
      <!-- TODO: Disabled for now -->
      <V2Button
        :variant="selectedStoreOption === STORE_OPTION.BY_SHIPPING_ADDRESS ? 'primary' : 'ghost'"
        block
        disabled
        @click="selectedStoreOption = STORE_OPTION.BY_SHIPPING_ADDRESS"
      >
        {{ STORE_OPTION.BY_SHIPPING_ADDRESS }}
      </V2Button>
    </div>
    <v-select
      v-model="selectedStores"
      :options="cartValuesList"
      label="storeName"
      placeholder="Select stores"
      multiple
      clearable
      :searchable="false"
      deselect-from-dropdown
    />

    <div class="v2-stores-list-block">
      <div
        v-for="cartValue in cartValuesList"
        :key="'store' + cartValue.storeId"
        class="v2-stores-list-item"
        @click="onSelectStore(cartValue)"
      >
        <input
          type="checkbox"
          class="v2-stores-list-checkbox"
          :checked="isSelected(cartValue)"
          @click.stop="onSelectStore(cartValue)"
        >
        <div class="v2-stores-list-name">
          {{ cartValue.storeName }}
        </div>
        <div
          v-if="!showOnlyList"
          class="v2-stores-list-badges"
        >
          <span class="v2-badge v2-badge-muted">
            Total units: {{ formatNumber(cartValue.totalUnits) || 0 }}
          </span>
          <span class="v2-badge v2-badge-muted">
            Total cost: {{ formatCurrency(Number(cartValue.totalValues), cartValue.currency) }}
          </span>
          <span class="v2-badge v2-badge-muted">
            Total RRP: {{ formatCurrency(Number(cartValue.totalRRP), cartValue.currency) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from '@/@core/utils/utils'
import { utils } from '@kingpin-global/kingpin-utils-frontend'
import vSelect from 'vue-select'
import V2Button from '@/components/v2/V2Button.vue'

const { formatCurrency } = utils

const STORE_OPTION = {
  BY_STORE: 'Select by store',
  BY_SHIPPING_ADDRESS: 'Select by shipping address',
}

export default {
  name: 'V2StoresList',
  components: {
    vSelect,
    V2Button,
  },
  props: {
    cartValuesList: {
      type: Array,
      required: true,
    },
    showOnlyList: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedStores: [],
      formatCurrency,
      formatNumber,
      STORE_OPTION,
      selectedStoreOption: STORE_OPTION.BY_STORE,
    }
  },
  watch: {
    selectedStores(val) {
      this.$emit('update-selected-stores', val)
    },
  },
  created() {
    this.selectedStores = this.cartValuesList
  },
  methods: {
    isSelected(cartValue) {
      const isChecked = this.selectedStores.find(store => store.storeId === cartValue.storeId)
      return !!isChecked
    },
    onSelectStore(cartValue) {
      const isStorePresent = this.selectedStores.find(store => store.storeId === cartValue.storeId)
      if (isStorePresent) {
        this.selectedStores = this.selectedStores.filter(store => store.storeId !== cartValue.storeId)
      } else {
        this.selectedStores.push(cartValue)
      }
    },
  },
}
</script>

<style lang="scss">
.v2-stores-list-container {
  .vs__dropdown-menu {
    display: none !important;
  }

  .vs__selected-options .vs__selected {
    background: var(--v2-muted);
    color: var(--v2-foreground);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-sm);
    padding: 2px 8px;
    font-size: 0.8125rem;
  }

  .vs__deselect svg {
    fill: var(--v2-muted-foreground);
  }
}
</style>

<style lang="scss" scoped>
.v2-stores-list-tabs {
  display: flex;
  gap: var(--v2-space-1);
  border: 1px solid var(--v2-border);
  border-radius: var(--v2-radius);
  padding: var(--v2-space-1);
  margin-bottom: var(--v2-space-2);
}

.v2-stores-list-block {
  border: 1px solid var(--v2-border);
  border-radius: var(--v2-radius);
  margin-top: var(--v2-space-2);
  max-height: 400px;
  overflow: auto;
}

.v2-stores-list-item {
  display: flex;
  align-items: center;
  padding: var(--v2-space-2) var(--v2-space-3);
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: var(--v2-muted);
  }
}

.v2-stores-list-checkbox {
  width: 16px;
  height: 16px;
  margin-right: var(--v2-space-2);
  accent-color: var(--v2-primary);
  cursor: pointer;
  flex-shrink: 0;
}

.v2-stores-list-name {
  font-family: var(--v2-font-sans);
  font-size: 0.875rem;
  color: var(--v2-foreground);
}

.v2-stores-list-badges {
  display: flex;
  margin-left: auto;
  gap: var(--v2-space-2);
}

.v2-badge {
  display: inline-flex;
  align-items: center;
  padding: var(--v2-space-1) var(--v2-space-2);
  font-size: 0.75rem;
  font-family: var(--v2-font-sans);
  border-radius: var(--v2-radius-sm);
  white-space: nowrap;
}

.v2-badge-muted {
  background: var(--v2-muted);
  color: var(--v2-foreground);
}
</style>
